import React, { useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { FaWhatsapp, FaInstagram } from "react-icons/fa";
import Swal from "sweetalert2";
import "./PaymentDetails.css";

const BASE_AMOUNT_COUPLE = 39000;
const BASE_AMOUNT_SINGLE = 27500;
const BED_1_AMOUNT = 12500;   // 1 extra bed
const BED_2_AMOUNT = 25000;   // 2 extra beds (12500 x 2)
const Nanny_AMOUNT = 14500;

const PaymentDetails = () => {
  const location = useLocation();
  const formData = location.state?.formData;
  const uploadedPhoto = location.state?.file;

  const [ssFile, setSsFile] = useState(null);
  const [ssError, setSsError] = useState("");
  const [loading, setLoading] = useState(false);

  if (!formData) {
    return <Navigate to="/" replace />;
  }

  const isCouple = formData.travellingStatus === "Couple";
  const isSingle = formData.travellingStatus === "Single";

  const calculateTotal = () => {
    const BASE_AMOUNT = isSingle ? BASE_AMOUNT_SINGLE : BASE_AMOUNT_COUPLE;
    let total = BASE_AMOUNT;
    const breakdown = [{ label: "Base Amount", amount: BASE_AMOUNT }];

    if (isCouple) {
      const numBeds = parseInt(formData.numberOfBeds, 10) || 0;

      if (numBeds === 1) {
        total += BED_1_AMOUNT;
        breakdown.push({ label: "Extra Bed (1)", amount: BED_1_AMOUNT });
      }

      if (numBeds === 2) {
        total += BED_2_AMOUNT;
        breakdown.push({ label: "Extra Beds (2)", amount: BED_2_AMOUNT });
      }

      if (formData.travellingNanny === "Yes") {
        total += Nanny_AMOUNT;
        breakdown.push({ label: "Nanny", amount: Nanny_AMOUNT });
      }
    }

    return { total, breakdown };
  };

  const { total, breakdown } = calculateTotal();

  const formatAmount = (amount) =>
    amount.toLocaleString("en-IN", { maximumFractionDigits: 0 });

  const handleSSUpload = (e) => {
    const selected = e.target.files[0];
    if (!selected) return;
    setSsFile(selected);
    setSsError("");
  };

  const handleConfirm = async () => {
    if (!ssFile) {
      setSsError("Please upload payment screenshot");
      return;
    }

    setLoading(true);

    try {
      const data = new FormData();

      data.append("travellingStatus", formData.travellingStatus);
      data.append("tablerName", formData.tablerName);
      data.append("mobileNumber", formData.mobileNumber);
      data.append("tableName", formData.tableName);
      data.append("shirtSize", formData.shirtSize);
      data.append("chairmanMessage", formData.chairmanMessage);

      if (isCouple) {
        data.append("numberOfBeds",        formData.numberOfBeds);
        data.append("spouseName",          formData.spouseName);
        data.append("circleNumber",        formData.circleNumber);
        data.append("circlerShirtSize",    formData.circlerShirtSize);
        data.append("circlerMobileNumber", formData.circlerMobileNumber);
        data.append("travellingKids",      formData.travellingKids);
        data.append("travellingNanny",      formData.travellingNanny);

        if (formData.travellingKids === "Yes") {
          data.append("noOfChildren", formData.noOfChildren);
          if (formData.child1Age) data.append("child1Age", formData.child1Age);
          if (formData.child2Age) data.append("child2Age", formData.child2Age);
          if (formData.child3Age) data.append("child3Age", formData.child3Age);
        }
      }

      data.append("totalAmount", total);

      data.append("image",             uploadedPhoto);
      data.append("paymentScreenshot", ssFile);

      const response = await fetch("https://area8agm2026.com/send.php", {
        method: "POST",
        body: data,
      });

      if (!response.ok) {
        const text = await response.text();
        console.error("Server error response:", text);
        throw new Error(`Server returned ${response.status}: ${text}`);
      }

      const result = await response.json();

  if (result.status === "success") {
  Swal.fire({
    icon: "success",
    title: "Registration Confirmed!",
    text: result.message,
    confirmButtonColor: "#25176e",
  }).then((result) => {
    if (result.isConfirmed) {
      window.location.href = "https://www.anantahotels.com/spa-and-resort-jaipur/";
    }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
          text: result.message,
        });
      }

    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Could not connect to server. Please try again.",
      });
    }

    setLoading(false);
  };

  return (
         <>
    <div className="paymentPage">
      <h1>Registration Summary</h1>

      <div className="summaryBox container">

       <p><strong>Travelling Status:</strong> {formData.travellingStatus}</p>
<p><strong>{isSingle ? "Tabler/Circler Name:" : "Tabler Name:"}</strong> {formData.tablerName}</p>
<p><strong>{isSingle ? "Table/Circle Name:" : "Table Name:"}</strong> {formData.tableName}</p>
<p><strong>Shirt Size:</strong> {formData.shirtSize}</p>
<p><strong>Mobile Number:</strong> {formData.mobileNumber}</p>

        {isCouple && (
          <>
        <p><strong>Extra Beds Required:</strong> {formData.numberOfBeds === "0" ? "None" : formData.numberOfBeds}</p>
            <p><strong>Spouse / Circler Name:</strong> {formData.spouseName}</p>
            <p><strong>Circle Number:</strong> {formData.circleNumber}</p>
            {/* <p><strong>Circler Shirt Size:</strong> {formData.circlerShirtSize}</p> */}
            <p><strong>Circler Mobile Number:</strong> {formData.circlerMobileNumber}</p>
            <p><strong>Travelling With Kids:</strong> {formData.travellingKids}</p>

            {formData.travellingKids === "Yes" && (
              <>
                <p><strong>No. of Children:</strong> {formData.noOfChildren}</p>
                {formData.child1Age && <p><strong>Child 1 Age:</strong> {formData.child1Age}</p>}
                {formData.child2Age && <p><strong>Child 2 Age:</strong> {formData.child2Age}</p>}
                {formData.child3Age && <p><strong>Child 3 Age:</strong> {formData.child3Age}</p>}
              </>
            )}

            <p><strong>Travelling With Nanny:</strong> {formData.travellingNanny}</p>
          </>
        )}

        <p><strong>Chairman Message:</strong> {formData.chairmanMessage}</p>

        {uploadedPhoto && (
          <p>
            <strong>{isSingle ? "Individual Photo:" : "Couple Photo:"}</strong> {uploadedPhoto.name}
          </p>
        )}

      </div>

      {/* ── Total Amount Breakdown ── */}
      <div className="totalAmountBox container">
        <h3>Amount Breakdown</h3>
        <table className="breakdownTable">
          <tbody>
            {breakdown.map((item, idx) => (
              <tr key={idx}>
                <td>{item.label}</td>
                <td>₹{formatAmount(item.amount)}/-</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="totalRow">
              <td><strong>Total Amount</strong></td>
              <td><strong>₹{formatAmount(total)}/-</strong></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="paymentBox container">
        <div className="left">
          <h2>Scan QR To Pay</h2>
          <p>Complete your payment and upload payment screenshot below.</p>

          <div className="bankDetails">
            <h3>Bank Transfer Details</h3>
            <table>
              <tbody>
                <tr>
                  <td><strong>A/c Name</strong></td>
                  <td>Bareilly Round Table 45</td>
                </tr>
                <tr>
                  <td><strong>Account No.</strong></td>
                  <td>007488700000804</td>
                </tr>
                <tr>
                  <td><strong>IFSC Code</strong></td>
                  <td>YESB0000074</td>
                </tr>
                <tr>
                  <td><strong>Bank Name</strong></td>
                  <td>Yes Bank</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="right">
          <div>
            <img src={require("../assets/qr.jpeg")} alt="QR Code" />
          </div>
          <div className="uploadRight mt-5">
            <span className="inlineTotal">Total: ₹{formatAmount(total)}/-</span>
          </div>
        </div>
      </div>

      {/* ── Upload Screenshot ── */}
      <div className="uploadSS container">
        <div className="uploadRow">
          <div className="uploadLeft">
            <label>Upload Payment Screenshot</label>
            <input type="file" accept="image/*" onChange={handleSSUpload} />
            {ssError && <span className="error">{ssError}</span>}
          </div>
        </div>
      </div>

      <button onClick={handleConfirm} disabled={loading}>
        {loading ? "Submitting..." : "Confirm Registration"}
      </button>

    </div>
     <div className="socialSection">
              <h3>Connect With Us</h3>
              <div className="socialIcons">
                <a href="https://www.instagram.com/rangdearea8?igsh=MTU0YmhqcmpsenE4NA==" target="_blank" rel="noreferrer" className="instagram">
                  <FaInstagram />
                </a>
               <a
  href="https://wa.me/919258997925"
  target="_blank"
  rel="noreferrer"
  className="whatsapp"
>
  <FaWhatsapp />
</a>
              </div>
                     </div>
              </>
  );
};

export default PaymentDetails;